import { BriefcaseIcon } from "@heroicons/react/20/solid";
import {
  ClockIcon,
  CheckCircleIcon,
  ClipboardDocumentCheckIcon,
  UserIcon,
  PhoneIcon,
  TagIcon,
  WrenchIcon,
  ShieldCheckIcon,
  ShieldExclamationIcon,
} from "@heroicons/react/24/outline";
import i18n from "i18next";

export function getAdminMenus() {
  return [
    {
      label: i18n.t("menu.orders"),
      icon: ClipboardDocumentCheckIcon,
      subMenus: [
        {
          label: i18n.t("menu.waitingOrders"),
          link: "/admin-orders-validation",
          icon: ClockIcon,
        },
        {
          label: i18n.t("menu.acceptedOrders"),
          link: "/acceptedOrders",
          icon: CheckCircleIcon,
        },
      ],
    },
    {
      label: i18n.t("Validation des actualités"),
      icon: ShieldCheckIcon,
      link: "/admin-news-validation-list",
    },
    {
      label: i18n.t("Gestion des permissions"),
      icon: ShieldExclamationIcon,
      link: "/admin/management/permissions",
    },
    {
      label: i18n.t("menu.ticketing"),
      icon: TagIcon,
      subMenus: [
        {
          label: i18n.t("menu.createTicketing"),
          link: "/ticketing/create",
          icon: TagIcon,
        },
        {
          label: i18n.t("menu.ticketing"),
          link: "/ticketings",
          icon: TagIcon,
        },
        {
          label: i18n.t("ticketing.ticketsValidation"),
          link: "/admin-tickets-validation",
          icon: TagIcon,
        },
      ],
    },
    {
      label: i18n.t("menu.customerService"),
      icon: UserIcon,
      subMenus: [
        {
          label: i18n.t("menu.toCall"),
          link: "/customers-to-call",
          icon: PhoneIcon,
        },
      ],
    },
    {
      label: i18n.t("menu.partners"),
      icon: UserIcon,
      subMenus: [
        {
          label: i18n.t("menu.companies"),
          link: "/admin-companies",
          icon: BriefcaseIcon,
        },
        {
          label: i18n.t("menu.providersPendingApproval"),
          link: "/providers-requests",
          icon: ClockIcon,
        },
        {
          label: i18n.t("menu.providersList"),
          link: "/providers-list",
          icon: CheckCircleIcon,
        },
      ],
    },
    {
      label: i18n.t("admin.userManagement"),
      icon: WrenchIcon,
      link: "/admin-user-list",
    },
  ];
}
